import React from 'react'

function Section2() {
  return (
  
        <div className='grid grid-cols-1 tablet:grid-cols-3 tabelt:pt-20'>
            <div>
                <img src='imgs/food6.jpg' className='w-11/12 mt-20 tablet:mt-0 mx-auto tablet:mx-0 shadow-[8px_10px_4px_rgba(249,201,130)]'/>
            </div>
          
               
            <div className='grid grid-cols-1 px-10 text-white-color'>
                <h3 className='text-center text-primary py-10 '>Sandwiches</h3>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>

                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>

                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-3'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
            </div>
       
            <div className='grid grid-rows-2 p-10'>
            <div className=' text-white-color'>
                <h3 className='text-center text-primary pb-10'>Soup</h3>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
            </div>  
            <div className='text-white-color'>
                <h3 className='text-center text-primary pb-10'>Drinks</h3>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
                <div className='flex justify-between my-6'>
                    <span>Grilled Cheese</span>
                    <span>5.350$</span>
                </div>
            </div>  
            </div>
        </div> 
  )
}

export default Section2